import { PaperBox } from "../../../../components/Layout/PaperBox";
import { formatarDecimalNumber } from "../../../../helpers/masks";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { TFornecedorMilho } from "../../../../types/api/cadastros/pesquisar-movimentacao-publico";

export default function CardFornecedorMilho({
    fornecedor
}: CardFornecedorMilhoProps) {

    const milhoArray = Object.values(fornecedor.milho).sort((a, b) => Number(b.safra_inicio) - Number(a.safra_inicio));

    return (
        <PaperBox title="Fornecedor milho">
            {
                milhoArray.length > 0 &&
                <TableContainer sx={{ maxHeight: 400 }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                {headers.map((item, index) => {
                                    return (
                                        <TableCell key={index} align={item.numeric ? 'right' : 'left'} sx={{ minWidth: item.width }}>
                                            <Typography fontWeight={'bold'} variant='subtitle2'>{item.label}</Typography>
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                milhoArray.map((item, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell sx={{ paddingX: 2 }}>
                                                {item.safra_inicio}/{item.safra_fim}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {`${formatarDecimalNumber(item.entrada, 2)}`}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {`${formatarDecimalNumber(item.saldo, 2)}`}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {`${formatarDecimalNumber(item.rd, 2)}`}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {`${formatarDecimalNumber(item.disponivel, 2)} Kg`}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, bgcolor: '#f5f5f5' }}
                            >
                                <TableCell component="th" scope="row" sx={{ paddingX: 2 }}>
                                    <b>Total:</b>
                                </TableCell>
                                <TableCell align="right">
                                    <b>{`${formatarDecimalNumber(fornecedor.total_entrada, 2)}`}</b>
                                </TableCell>
                                <TableCell align="right">
                                    <b>{`${formatarDecimalNumber(fornecedor.total_saldo, 2)}`}</b>
                                </TableCell>
                                <TableCell align="right">
                                    <b>{`${formatarDecimalNumber(fornecedor.total_rd, 2)}`}</b>
                                </TableCell>
                                <TableCell align="right">
                                    <b>{`${formatarDecimalNumber(fornecedor.total_disponivel, 2)} Kg`}</b>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </PaperBox>
    )
}

interface CardFornecedorMilhoProps {
    fornecedor: TFornecedorMilho;
}

const headers = [
    {
        label: "Safra",
        numeric: false,
        width: '100%'
    },
    {
        label: "Entradas",
        numeric: true,
        width: '100%'
    },
    {
        label: "Saldo",
        numeric: true,
        width: '100%'
    },
    {
        label: "(-)RD",
        numeric: true,
        width: '140px'
    },
    {
        label: "Disponível",
        numeric: true,
        width: '140px'
    },
]
